// source: advai_event/pintar_id/action.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = globalThis

goog.exportSymbol('proto.advai_event.pintar_id.Action', null, global)
/**
 * @enum {number}
 */
proto.advai_event.pintar_id.Action = {
  ACTIONNULL: 0,
  PAGEEVENT: 1,
  MOBILENOCLICK: 2,
  MOBILENOINPUT: 3,
  STARTCLICK: 4,
  FBOTPVERIFYRESULT: 5,
  SMSOTPWINDOWDISPLAY: 6,
  SMSOTPWINDOWCLICKOK: 7,
  SMSOTPWINDOWCLICKNO: 8,
  RESENDSMSDISPLAY: 9,
  RESENDSMSCLICK: 10,
  RESENDVOICEDISPLAY: 11,
  RESENDVOICECLICK: 12,
  SMSOTPCLICK: 13,
  SMSOTPINPUT: 14,
  SMSOTPVERIFYRESULT: 15,
  APPLYNOWCLICK: 16,
  COLLECTDATAWINDOWDISPLAY: 17,
  AGREECLICK: 18,
  SHAREATOMECLICK: 19,
  CHECKNOWCLICK: 20,
  RATEATOMEWINDOWDISPLAY: 21,
  RATEATOMEWINDOWCLOSE: 22,
  RATEATOMECLICK: 23,
  ORDERDETAILSCLICK: 24,
  CHANGEBANKCARDCLICK: 25,
  CLAIMINSTANTAPPROVALCLICK: 26,
  LOANAMOUNTSLIDE: 27,
  REPAYMENTPLANCLICK: 28,
  NKPAPPLYCLICK: 29,
  NKPAPPLYRESULT: 30,
  OKPAPPLYCLICK: 31,
  PAYCLICK: 32,
  FUTUREBILLCLICK: 33,
  PREPAYALLCLICK: 34,
  BILLHISTORYCLICK: 35,
  BILLSTATEMENTCLICK: 36,
  BILLSTATEMENTDETAILCLICK: 37,
  PAYMENTMETHODENTER: 38,
  VIRTUALACCOUNTTABCLICK: 39,
  VIRTUALACCOUNTCOPYCLICK: 40,
  HOWTOPAYCLICK: 41,
  REPAYMENTRECORDCLICK: 42,
  PAYMENTCODETABCLICK: 43,
  GETPAYMENTCODECLICK: 44,
  LIVECHATCLICK: 45,
  LOGOUTCLICK: 46,
  CAMERACLICK: 47,
  TAKEPICCLICK: 48,
  RETAKECLICK: 49,
  USEPHOTOCLICK: 50,
  PREAUDITRESULT: 51,
  NEXTBTNCLICK: 52,
  SKIPCLICK: 53,
  SUPPMATERIALCLICK: 54,
  SUPPMATERIALCLICKADD: 55,
  SUPPMATERIALCLICKSUBMIT: 56,
  SUPPMATERIALSUBMITRESULT: 57,
  APPLYSUBMITCLICK: 58,
  APPLYRESULT: 59,
  DEVICEINFOUPLOADRESULT: 60,
  APPLYSTEPCLICK: 61,
  APPLYLOANSUPPMATERIALCLICK: 62,
  APPLYLOANPURPOSECLICK: 63,
  APPLYLOANPURPOSESELECT: 64,
  APPLYLOANSUBMITCLICK: 65,
  BANKNAMECLICK: 66,
  BANKNAMESELECT: 67,
  BANKACCCLICK: 68,
  BANKACCINPUT: 69,
  REENTERBANKACCCLICK: 70,
  REENTERBANKACCINPUT: 71,
  BANKCARDSUBMITCLICK: 72,
  BANKCARDSUBMITRESULT: 73,
  OKPAPPLYRESULT: 74,
  MODIFYKTPNOCLICK: 75,
  MODIFYKTPNAMECLICK: 76,
  ENTERAPPLYLOAN: 77,
  APPLYLOANSUBMITRESULT: 78,
  ENTERHOME: 79,
  APPROVALWINDOWSHOW: 80,
  APPROVALWINDOWHIDE: 81,
  ENTERBILL: 82,
  NEXTBTNCLICKRESULT: 83,
  SMSOTPSHOW: 84,
  SMSOTPHIDE: 85,
  APPOPEN: 86,
  REMARKETINGAPPOPENINFO: 87,
  ADCLICK: 88,
  QUESTIONICONCLICK: 89,
  SMSREFERCLICK: 90,
  WAREFERCLICK: 91,
  FBREFERCLICK: 92,
  LINKREFERCLICK: 93,
  DETAILICONCLICK: 94,
  RETURNPOPUPSHOW: 95,
  RETURNPOPUPSHARENOWCLICK: 96,
  RETURNPOPUPGIVEUPCLICK: 97,
  CAMERAPERMISSIONSHOW: 98,
  CAMERAPERMISSIONALLOW: 99,
  CAMERAPERMISSIONDENY: 100,
  MOREDETAILSCLICK: 101,
  GOTITCLICK: 102,
  CLOSECLICK: 103,
  EMAILCLICK: 104,
  EMAILINPUT: 105,
  BIRTHPLACECLICK: 106,
  BIRTHPLACEINPUT: 107,
  MARITALSTATUSSELECT: 108,
  EDUCATIONSELECT: 109,
  DEPENDENTSSELECT: 110,
  MOTHERMAIDENCLICK: 111,
  MOTHERMAIDENINPUT: 112,
  NPWPCLICK: 113,
  NPWPINPUT: 114,
  FIRSTCONTACTRELATIONSELECT: 115,
  FIRSTCONTACTNAMECLICK: 116,
  FIRSTCONTACTNAMEINPUT: 117,
  FIRSTCONTACTMOBILECLICK: 118,
  FIRSTCONTACTMOBILEINPUT: 119,
  SECONDCONTACTRELATIONSELECT: 120,
  SECONDCONTACTNAMECLICK: 121,
  SECONDCONTACTNAMEINPUT: 122,
  SECONDCONTACTMOBILECLICK: 123,
  SECONDCONTACTMOBILEINPUT: 124,
  RESIDENTIALSTATUSSELECT: 125,
  HOMEPHONECLICK: 126,
  HOMEPHONEINPUT: 127,
  PROVINCESELECT: 128,
  CITYSELECT: 129,
  REGIONSELECT: 130,
  VILLAGESELECT: 131,
  YOURVILLAGECLICK: 132,
  YOURVILLAGEINPUT: 133,
  ZIPCODECLICK: 134,
  ZIPCODEINPUT: 135,
  ADDRESSCLICK: 136,
  ADDRESSINPUT: 137,
  JOBINDUSTRYSELECT: 138,
  JOBTYPESELECT: 139,
  JOBPOSITIONSELECT: 140,
  COMPANYNAMECLICK: 141,
  COMPANYNAMEINPUT: 142,
  WORKSINCESELECT: 143,
  INCOMECLICK: 144,
  INCOMEINPUT: 145,
  BIZPHONECLICK: 146,
  BIZPHONEINPUT: 147,
  BIZADDRESSCLICK: 148,
  BIZADDRESSINPUT: 149,
  ACCNOCLICK: 150,
  ACCNOINPUT: 151,
  REENTERACCNOCLICK: 152,
  REENTERACCNOINPUT: 153,
  DEPRECATEDFIELD1: 154,
  SECURITYCHECK: 155,
  PUSHDISPLAY: 156,
  PUSHCLICK: 157,
  LOWINTERESTLOANCLICK: 158,
  SHOPNOWCLICK: 159,
  LANGUAGECLICK: 160,
  LANGUAGESELECT: 161,
  READALLCLICK: 162,
  DISPLAYMODULEPROGRESS: 163,
  VIRTUALACCOUNTSLIDE: 164,
  PAYMENTINSTRUCTIONSHOW: 165,
  PAYMENTINSTRUCTIONHIDE: 166,
  TURNOFFNOTIFICATIONSCLICK: 167,
  SIGNOUTOPTIONCLICK: 168,
  MOBILEHELPCLICK: 169,
  EMAILHELPCLICK: 170,
  FAQDETAILSSHOW: 171,
  FAQDETAILSHIDE: 172,
  DOCUMENTUPLOADCOMPLETE: 173,
  MARITALSTATUSCLICK: 174,
  EDUCATIONCLICK: 175,
  DEPENDENTSCLICK: 176,
  FIRSTCONTACTRELATIONCLICK: 177,
  RESIDENTIALSTATUSCLICK: 178,
  PROVINCECLICK: 179,
  CITYCLICK: 180,
  REGIONCLICK: 181,
  VILLAGECLICK: 182,
  JOBINDUSTRYCLICK: 183,
  JOBTYPECLICK: 184,
  JOBPOSITIONCLICK: 185,
  WORKSINCECLICK: 186,
  MOBILENUMBERDELETE: 187,
  EMAILDELETE: 188,
  BIRTHPLACEDELETE: 189,
  MOTHERMAIDENDELETE: 190,
  NPWPDELETE: 191,
  FIRSTCONTACTNAMEDELETE: 192,
  FIRSTCONTACTMOBILEDELETE: 193,
  SECONDCONTACTNAMEDELETE: 194,
  SECONDCONTACTMOBILEDELETE: 195,
  HOMEPHONEDELETE: 196,
  YOURVILLAGEDELETE: 197,
  ZIPCODEDELETE: 198,
  ADDRESSDELETE: 199,
  COMPANYNAMEDELETE: 200,
  BIZPHONEDELETE: 201,
  BIZADDRESSDELETE: 202,
  ACCNODELETE: 203,
  REENTERACCNODELETE: 204,
  SECONDCONTACTRELATIONCLICK: 205,
  COLLECTIONDATAPERMISSIONSHOW: 206,
  COLLECTIONDATAPERMISSIONALLOW: 207,
  COLLECTIONDATAPERMISSIONDENY: 209,
  COLLECTIONDATALACKOFAUTHORIZATIONSHOW: 210,
  COLLECTIONDATALACKOFAUTHORIZATIONDENY: 211,
  COLLECTIONDATALACKOFAUTHORIZATIONALLOW: 212,
  COLLECTIONDATAAUTHORIZATIONFAILEDSHOW: 213,
  COLLECTIONDATAAUTHORIZATIONFAILEDDENY: 214,
  CAMERALACKOFAUTHORIZATIONSHOW: 216,
  CAMERALACKOFAUTHORIZATIONDENY: 217,
  CAMERALACKOFAUTHORIZATIONALLOW: 218,
  CAMERAAUTHORIZATIONFAILEDSHOW: 219,
  CAMERAAUTHORIZATIONFAILEDDENY: 220,
  CAMERARESULT: 221,
  KTPFACEDETECTIONRESULT: 222,
  KTPHOLDINGFACEDETECTIONRESULT: 223,
  CAMERABACKCLICK: 224,
  CAMERACANCELCLICK: 225,
  SEEDETAILCLICK: 226,
  APPINSTALL: 227,
  REFERFRIENDSSHOW: 228,
  SYSTEMDNSSUCCESS: 229,
  HTTPDNSSUCCESS: 230,
  HTTPDNSFAILED: 231,
  RETURNCLICK: 232,
  PRODUCTSELECT: 233,
  PRODUCTDESELECT: 234,
  PRODUCTDETAILSHOW: 235,
  PRODUCTDETAILHIDE: 236,
  POPUPSHOW: 237,
  POPUPHIDE: 238,
  WEBVIEWLOAD: 239,
  WEBVIEWLOADERROR: 240,
  REMINDERPOPUPSHOW: 241,
  REMINDERPOPUPMAYBELATERCLICK: 242,
  REMINDERPOPUPSHOWMORECLICK: 243,
  WINDOWSLIDE: 244,
  CONTINUECLICK: 245,
  GUIDEPICTURECLICK: 246,
  CAMERAOPEN: 247,
  CAMERASWITCH: 248,
  FLASHSWITCH: 249,
  PHOTOANALYSISCOMPLETE: 250,
  PHOTOUPLOADCOMPLETE: 251,
  FACEDETECTIONFAILURESHOW: 252,
  PHOTOUPLOADFAILUREPOPUPSHOW: 253,
  PHOTOUPLOADFAILUREPOPUPRETRYCLICK: 254,
  PHOTOUPLOADFAILUREPOPUPRETURNCLICK: 255,
  KTPRESULTENTER: 256,
  KTPHOLDINGRESULTENTER: 257,
  PHOTOCLICK: 258,
  SUBMITCLICK: 259,
  SUBMITRESULT: 260,
  PREAUDITERRORPOPUPSHOW: 261,
  PAGEDURATION: 262,
  EMAILCURSOROUT: 263,
  BIRTHPLACECURSOROUT: 264,
  MOTHERMAIDENCURSOROUT: 265,
  NPWPCURSOROUT: 266,
  AREASELECTRESULT: 267,
  COMPANYNAMECURSOROUT: 268,
  INCOMECURSOROUT: 269,
  BIZPHONECURSOROUT: 270,
  BIZADDRESSCURSOROUT: 271,
  ACCNOCURSOROUT: 272,
  REENTERACCNOCURSOROUT: 273,
  LOANAGREECLICK: 274,
  HOMEPHONECURSOROUT: 275,
  FIRSTCONTACTNAMECURSOROUT: 276,
  FIRSTCONTACTMOBILECURSOROUT: 277,
  SECONDCONTACTNAMECURSOROUT: 278,
  SECONDCONTACTMOBILECURSOROUT: 279,
  ZIPCODECURSOROUT: 280,
  CAMERAPERMISSIONRESULT: 281,
  AREACLICK: 282,
  ADDRESSCURSOROUT: 283,
  YOURVILLAGECURSOROUT: 284,
  INCOMEDELETE: 285,
  HELPICONCLICK: 286,
  INFOICONCLICK: 287,
  LINKCLICK: 288,
  ACCOUNTCLICK: 289,
  ACCOUNTCURSOROUT: 290,
  PASSWORDCLICK: 291,
  PASSWORDCURSOROUT: 292,
  CHOOSEVOUCHERCLICK: 293,
  VOUCHERCLICK: 294,
  USEVOUCHERCLICK: 295,
  CLOSECHOOSEVOUCHERCLICK: 296,
  TOASTSHOW: 297,
  MYVOUCHERSENTER: 298,
  VALIDTABSWITCH: 299,
  USEDTABSWITCH: 300,
  EXPIREDTABSWITCH: 301,
  NOOVERDUEPOPUPSHOW: 302,
  NOOVERDUEPOPUPNOCLICK: 303,
  NOOVERDUEPOPUPAPPLYCLICK: 304,
  USECLICK: 305,
  BANKLINKCLICK: 306,
  SUPPLINKCLICK: 307,
  SUBMITDOCCLICK: 308,
  SUBMITWITHOUTDOCCLICK: 309,
  KTPPOPUPSHOW: 310,
  GOTOEXISTINGACCOUNTCLICK: 311,
  ADFLOATCLICK: 312,
  ADBANNERCLICK: 313,
  NOTHANKSCLICK: 314,
  ENTERSTART: 315,
  VERIFYCLICK: 316,
  SENDINPUTTIMEDIFF: 317,
  SENDVERIFYTIMEDIFF: 318,
  ENTERPRESCREENDOCUPLOAD: 319,
  PRESCREENDOCLINKCLICK: 320,
  ADDPHOTOCLICK: 321,
  UPLOADEDTHUMBNAILCLICK: 322,
  DELETECLICK: 323,
  EXAMPLECLICK: 324,
  PAGESHOW: 325,
  PAGEHIDE: 326,
  QUESTIONCLICK: 327,
  TOPICCLICK: 328,
  ENTERHELPCENTER: 329,
  BILLTABSWITCH: 330,
  EXPANDCLICK: 331,
  COLLAPSECLICK: 332,
  BILLSTATEMENTSCLICK: 333,
  CURRENTBILLCLICK: 334,
  PAYALLCLICK: 335,
  ALLBILLTABSWITCH: 336,
  ENTERSTATEMENTDETAILS: 337,
  STATEMENTDETAILSTABSWITCH: 338,
  ENTERBILLSTATEMENTS: 339,
  BILLSTATEMENTSTABSWITCH: 340,
  INITIALPROFILEACQUIRED: 341,
  GPSREADY: 342,
  SHARENOWCLICK: 343,
  TERMSCONDITIONSCLICK: 344,
  SHARETOPOPUPSHOW: 345,
  SHARETOPOPUPHIDE: 346,
  TERMSCONDITIONSPOPUPSHOW: 347,
  TERMSCONDITIONSPOPUPHIDE: 348,
  ENTERREWARDSDETAIL: 349,
  TYPECLICK: 350,
  TYPESELECT: 351,
  DATECLICK: 352,
  DATESELECT: 353,
  ENTERACCEPTINVITATION: 354,
  MOBILENOCHECK: 355,
  ACCEPTINVITATIONCLICK: 356,
  REFERRERREWARDSPOPUPSHOW: 357,
  REFERRERREWARDSPOPUPCLICKCHECK: 358,
  REFEREEREWARDSPOPUPSHOW: 359,
  REFEREEREWARDSPOPUPCLICKAPPLY: 360,
  REGISTEREDREFEREEPOPUPSHOW: 361,
  REGISTEREDREFEREEPOPUPCLICKGETREWARD: 362,
  READCONTACTSCLICK: 363,
  REWARDBANNERCLICK: 364,
  EXTENSIONAPPLYNOWCLICK: 365,
  PAYNOWCLICK: 366,
  CHECKAGREE: 367,
  UNCHECKAGREE: 368,
  LOANAGREEMENTCLICK: 369,
  EXTENSIONAPPLYRESULT: 370,
  PAGEPARAMETER: 371,
  VOUCHERPOPUPSHOW: 372,
  VOUCHERPOPUPMAYBELATERCLICK: 373,
  VOUCHERPOPUPUSENOWCLICK: 374,
  VOUCHERGUIDEMODALSHOW: 375,
  VOUCHERGUIDEGOTITCLICK: 376,
  WELCOMEPOPUPSHOW: 377,
  POLICYCLICK: 378,
  OKBUTTONCLICK: 379,
  ORDERDETAILCLICK: 380,
  DOWNPAYMENTPLANCLICK: 381,
  SUBTOTALCLICK: 382,
  INSTALLMENTPLANCLICK: 383,
  AGREEMENTRADIOBUTTONCLICK: 384,
  LOGINDIALOGSHOW: 385,
  LOGINDIALOGCLOSE: 386,
  VERIFYBUTTONCLICK: 387,
  VERIFYCLICKRESULT: 388,
  PAGESTATUS: 389,
  CHECKNOWBUTTONCLICK: 390,
  BACKTOMERCHANTBUTTONCLICK: 391,
  VERIFYCODEINPUT: 392,
  NEXTBUTTONCLICK: 393,
  KTPNOINPUT: 394,
  KTPNOVERIFYRESULT: 395,
  TOOMANYATTEMPTSDIALOGSHOW: 396,
  PERSONALINFORMATIONCLICK: 397,
  HOMEPAGELOADING: 398,
  USECOUPONCLICK: 399,
  COUPONAPPLYRESULT: 400,
  GOTOPAYCLICK: 401,
  BANNERCLICK: 402,
  WITHDRAWCLICK: 403,
  TOTURIALSCLICK: 404,
  TOTURIALSPOPUPSHOW: 405,
  TOTURIALSPOPUPCLOSE: 406,
  INVITEFRIENDSCLICK: 407,
  INVITECODECLICK: 408,
  INVITELINKCLICK: 409,
  QRCODECLICK: 410,
  CHECKINCLICK: 411,
  REFERRALCODEENTERCLICK: 412,
  REFERRALCODEINPUTCLICK: 413,
  REFERRALCODEINPUT: 414,
  CANCELCLICK: 415,
  CONFIRMCLICK: 416,
  REFERRALCODEVERIFYRESULT: 417,
  CLAIMCLICK: 418,
  PHONENUMINPUTCLICK: 419,
  PHONENUMINPUT: 420,
  GIFTCLAIMCLICK: 421,
  PHONEVERIFYRESULT: 422,
  GOTREWARDPOPUPSHOW: 423,
  DOWNLOADCLICK: 424,
  CLOSEREWARDPOPUPCLICK: 425,
  ENTERKPCLICK: 426,
  LEAVEPAGE: 427,
  SLIDESTART: 428,
  SLIDEEND: 429,
  NEWSCLICK: 430,
  ADSCLICK: 431,
  ADSSCREENSHOW: 432,
  ADSSCREENCLOSE: 433,
  READORIGINALCLICK: 434,
  VIDEOPLAY: 435,
  VIDEOSTOP: 436,
  ENTERPAGE: 437,
  INVITECONFIRMPOPUPSHOW: 438,
  ACCEPTCLICK: 439,
  REJECTCLICK: 440,
  POINTSLOADMORECLICK: 441,
  GOOGLEPLAYCLICK: 442,
  ADSLOADRESULT: 443,
  TOPADSCLICK: 444,
  REWARDIMAGELOADRESULT: 445,
  ACCEPTNEWUSERREWARD: 446,
  CLOSENEWUSERREWARD: 447,
  GETVOUCHERCLICK: 448,
  CHECKINRESULT: 449,
  LOTTERYCLICK: 450,
  DRAWCLICK: 451,
  DRAWRESULT: 452,
  POINTSGUIDESHOW: 453,
  POINTSGUIDECLOSE: 454,
  WATCHADSPOPUPSHOW: 455,
  WATCHADSPOPUPCLOSE: 456,
  WATCHADSCLICK: 457,
  NEWSCATEGORYSELECTED: 458,
  APPLYLOANRETURNCLICK: 459,
  APPLYLOANYESCLICK: 460,
  APPLYLOANCHECKAGAINCLICK: 461,
  CHOOSELOANPRODUCTCLICK: 462,
  OKPPRODUCTCLICK: 463,
  DETECTIONRESULT: 464,
  TRYAGAINCLICK: 465,
  NEXTCLICK: 466,
  RECOMMENDATIONPOPUPSHOW: 467,
  RECOMMENDPOPUPAPPLYNOWCLICK: 468,
  POPUPCLOSE: 469,
  KYCENTRANCECLICK: 470,
  MSGRECEIVED: 471,
  PENDINGMSGLIST: 472,
  POPUPSTARTLOADING: 473,
  POPUPLOADSUCCESS: 474,
  POPUPLOADFAILED: 475,
  ENTERACCELERATELOAN: 476,
  HANDLEVEDIOCALLCLICK: 477,
  HRNAMECLICK: 479,
  HRNAMECURSOROUT: 480,
  CONTACTMOBILEINPUT: 481,
  CONTACTMOBILECURSOROUT: 482,
  POPUPLOADCANCELLED: 483,
  HRNAMEINPUT: 484,
  CONTACTMOBILECLICK: 485,
  ENTERACTIVITYPAGE: 486,
  ACTIVITYRULESCLICK: 487,
  KPLOTTERYCLICK: 488,
  MYREWARDSCLICK: 489,
  LOTTERYCHECKINCLICK: 490,
  LOTTERYGOCLICK: 491,
  LOTTERYPAYBILLCLICK: 492,
  LOTTERYSUPPLEMENTCLICK: 493,
  ACCOUNTCENTERCLICK: 494,
  ENTERMYACCOUNT: 495,
  USERNAMECLICK: 496,
  PROFILECLICK: 497,
  ENTERMYPROFILE: 498,
  PERSONALINFOCLICK: 499,
  CONTACTINFOCLICK: 500,
  RESIDENTIALINFOCLICK: 501,
  WORKINFOCLICK: 502,
  LINKACCOUNTCLICK: 503,
  ENTERMYLINKACCOUNT: 504,
  ACCOUNTLINKCLICK: 505,
  USERIDCOPYCLICK: 506,
  SAVECLICK: 507,
  PAYDAYCLICK: 508,
  PAYDAYCURSOROUT: 509,
  PAYDAYINPUT: 510,
  PAYDAYDELETE: 511,
  CONTACTRELATIONCLICK: 512,
  CONTACTRELATIONSELECT: 513,
  CONTACTNAMECLICK: 514,
  CONTACTNAMEINPUT: 515,
  CONTACTNAMEDELETE: 516,
  CONTACTNAMECURSOROUT: 517,
  CONTACTMOBILEDELETE: 518,
  FACEIDCLICK: 519,
  FACEDETECTIONRESULT: 520,
  PHONENUMCLICK: 521,
  REASONCLICK: 522,
  LOGINDIALOGDISPLAY: 523,
  LOGINDIALOGCONFIRM: 524,
  LOGINDIALOGHIDE: 525,
  LOGINDIALOGCANCEL: 526,
  NEXTCLICKRESULT: 527,
  ERRORDIALOGDISPLAY: 528,
  ERRORDIALOGCONFIRM: 529,
  MOBILEINPUTCHANGE: 530,
  CALENDARCLICK: 531,
  POINTSRULESCLICK: 532,
  POINTSCLICK: 533,
  POINTSRECORDSCLICK: 534,
  POINTSTYPECLICK: 535,
  POINTSEXCHANGERECORDSCLICK: 536,
  EXCHANGERECORDCLICK: 537,
  TASKSHOWCLICK: 538,
  GOODSEXCHANGECLICK: 539,
  ENTERPOINTSEXCHANGEPAGE: 540,
  EXCHANGECLICK: 541,
  EARNPIONTSCLICK: 542,
  POINTSNOTENOUGHDIALOGDISPLAY: 543,
  POINTSNOTENOUGHCONFIRM: 544,
  POINTSNOTENOUGHDIALOGCANCEL: 545,
  POINTSCHECKINCLICK: 546,
  VIEWEXCHANGERECORDCLICK: 547,
  PLACEORDERCLICK: 548,
  NOTIFICATIONDIALOGDISPLAY: 549,
  NOTIFICATIONDIALOGCONFIRM: 550,
  EARNPOINTSOKCLICK: 551,
  POINTCENTERCLICK: 552,
  OKCLICK: 553,
  DONECLICK: 554,
  ENTERFACEDETECTION: 555,
  NOTIFICATIONID: 556,
  MYVOUCHERSCLICK: 557,
  VIEWDETAILSCLICK: 558,
  REDEEMCLICK: 559,
  VOUCHERINSTRUCTIONDIALOGSHOW: 560,
  VOUCHERINSTRUCTIONDIALOGCONFIRM: 561,
  ELIGIBLEVOUCHERLISTDIALOGSHOW: 562,
  INSREFERCLICK: 563,
  TWITTERREFERCLICK: 564,
  SHARETOSOCIALMEDIACLICK: 565,
  BANNEROBSERVE: 566,
  FLOATBUTTONOBSERVE: 567,
  FLOATBUTTONCLICK: 568,
  MASCOTMESSAGEOBSERVE: 569,
  MASCOTMESSAGECLICK: 570,
  MASCOTMESSAGECLOSE: 571,
  LEADINGWORDSMORECLICK: 572,
  PINTARSCOREHISTORYCLICK: 573,
  RULEDESCRIPTIONCLICK: 574,
  PINTARSCOREPERSONALINFOCLICK: 575,
  PINTARSCOREORDERCLICK: 576,
  CREDITBENEFITSCLICK: 577,
  GOPOINTSCLICK: 578,
  APPLYLIMITCLICK: 579,
  PINTARSCORECLICK: 580,
  VOUCHERSSHOWCLICK: 581,
  VOUCHERLABEL: 582,
  SHAREEXPERIENCECLICK: 583,
  USERDETECTIONRESULT: 584,
  ENTERKPWEBSITE: 585,
  KPDOWNLOADAPPCLICK: 586,
  KPDOWNLOADCLICK: 587,
  KPFLOATBTNCLICK: 588,
  KPNAVIGATIONCLICK: 589,
  STARTTOTAKEPHOTOCLICK: 590,
  KTPPHOTOCLICK: 591,
  SELFIEKTPCLICK: 592,
  INPUTFOCUS: 593,
  INPUTCHANGE: 594,
  INPUTBLUR: 595,
  DATEOFBIRTHCLICK: 596,
  DATEOFBIRTHSELECT: 597,
  ADDRESSSELECT: 598,
  RESIDENTIALSELECTRESULT: 599,
  KPAPPLYNOWCLICK: 600,
  KPLEARNMORECLICK: 601,
  ADLOADED: 602,
  VKYCOKBTNCLICK: 603,
  HANDLEVIDEOCALLCLICK: 604,
  PICUPLOADCLICK: 605,
  PICUPLOADSUBMITCLICK: 606,
  PICUPLOADSUBMITRESULT: 607,
  MYSCORECLICK: 608,
  TABCLICK: 609,
  DELETEPICCLICK: 610,
  DOCUMENTUPLOADRESULT: 611,
  PICUPLOADCLOSECLICK: 612,
  ENTERPINTARSCORE: 613,
  CHANGECARDCLICK: 614,
  CHECKCARD: 615,
  NEWBANKCARDCLICK: 616,
  PRIZEHISTORYCLICK: 617,
  PRIZELISTCLICK: 618,
  CHOOSEPRIZEINFOCLICK: 619,
  ENTERGASHAPON: 620,
  PLAYNOWCLICK: 621,
  GASHAPONDIALOGDISPLAY: 622,
  GASHAPONDIALOGCONFIRM: 623,
  GASHAPONDIALOGCANCEL: 624,
  VIEWMYPRIZECLICK: 625,
  EDITADDRESSCLICK: 626,
  DEFAULTADDRESSCLICK: 627,
  DELETEADDRESSCLICK: 628,
  DELETEADDRESSDIALOGDISPLAY: 629,
  DELETEADDRESSDIALOGCONFIRM: 630,
  DELETEADDRESSDIALOGCANCEL: 631,
  SAVECLICKRESULT: 632,
  ENTERPINTARSHOPCLICK: 633,
  FAQCLICK: 634,
  PINTARCOINSCLICK: 635,
  ADBANNERSHOW: 636,
  REDEMPTIONPRODUCTSLIDE: 637,
  REDEMPTIONPRODUCTCLICK: 638,
  REDEMPTIONVIEWALLCLICK: 639,
  ENTERPRODUCTDETAIL: 640,
  BUTTONCLICK: 641,
  ERRORDIALOGSHOW: 642,
  ERRORDIALOGCANCEL: 643,
  MYCOINSCLICK: 644,
  TABSWITCH: 645,
  SKUSHOW: 646,
  SKUCLICK: 647,
  WATCHNOWCLICK: 648,
  EARNCOINSDIALOGSHOW: 649,
  EARNCOINSDIALOGCONFIRM: 650,
  EARNCOINSDIALOGCANCEL: 651,
  PINTARDISCOVERCLICK: 652,
  ARTICLEOBSERVE: 653,
  COMMENTOBSERVE: 654,
  FINISHVIEWCOMMENT: 655,
  REFRESHFEEDLISTRESULT: 656,
  CHANGECATEGORYCLICK: 657,
  SUBMITCOMMENTCLICK: 658,
  LIKEORDISLIKEARTICLECLICK: 659,
  ARTICLEDETAILSCLICK: 660,
  ARTICLESHAREBUTTONCLICK: 661,
  ARTICLESHARETARGETAPPCLICK: 662,
  ARTICLESHARERESULT: 663,
  ENTERSEIZETREASURECLICK: 664,
  CTABUTTONCLICK: 665,
  TANDCSCLICK: 666,
  MYAPPLICATIONSSHOW: 667,
  MYAPPLICATIONSCLICK: 668,
  HEADERICONCLICK: 669,
  HEADERICONSHOW: 670,
  SIGNNOWBUTTONCLICK: 671,
  AGREELOANAGREEMENTBUTTONCLICK: 672,
  RESENDSMSCODEBUTTONCLICK: 673,
  SMSVERIFYRESULT: 674,
  ENTERFAQCLICK: 675,
  QUESTIONSCLICK: 676,
  SIGNDONEBUTTONCLICK: 677,
  LOANAGREEMENTLISTCLICK: 678,
  ENTERAGREEMENTLISTCLICK: 679,
  AGREEMENTLISTSUBMITBUTTONCLICK: 681,
  CHECKINPAGEOBSERVE: 682,
  CHECKINPOPUPOBSERVE: 683,
  CHECKINPOPUPCLICK: 684,
  NIKCLICK: 685,
  NIKINPUT: 686,
  NIKDELETE: 687,
  NIKCURSOROUT: 688,
  FULLNAMECLICK: 689,
  FULLNAMEINPUT: 690,
  FULLNAMEDELETE: 691,
  FULLNAMECURSOROUT: 692,
  BIRTHDATECLICK: 693,
  BIRTHDATESELECT: 694,
  RTCLICK: 695,
  RTINPUT: 696,
  RTDELETE: 697,
  RTCURSOROUT: 698,
  RWCLICK: 699,
  RWINPUT: 700,
  RWDELETE: 701,
  RWCURSOROUT: 702,
  APPLEAVE: 703,
  HTTPQUALITY: 704,
  GETSTAREDBUTTONCLICK: 705,
  PHONENUMBERFIELDCHANGE: 706,
  PHONENUMBERFIEDBLUR: 707,
  RESENDSMSCODELINKCLICK: 708,
  LOGINBUTTONCLICK: 709,
  LOGINWITHPASSWORDBUTTONCLICK: 710,
  LOGINCHECKRESULT: 711,
  LOGINOTPFAQICONCLICK: 712,
  SKIPLINKCLICK: 713,
  CONFIRMSKIPBUTTONCLICK: 714,
  CREATEITNOWBUTTONCLICK: 715,
  FORGETPASSWORDLINKCLICK: 716,
  LOGINWITHSMSCODEBUTTONCLICK: 717,
  LOGINWITHFACEIDBUTTONCLICK: 718,
  STARTBUTTONCLICK: 719,
  DONEBUTTONCLICK: 720,
  SENDCODELINKCLICK: 721,
  SUBMITBUTTONCLICK: 722,
  HIDDENPASSWORDSWITCHCLICK: 723,
  SMSCODEFIEDBLUR: 724,
  SMSCODEFIEDCHANGE: 725,
  PASSWORDFIEDBLUR: 726,
  PASSWORDFIEDCHANGE: 727,
  REENTERPASSWORDFIEDBLUR: 728,
  REENTERPASSWORDFIEDCHANGE: 729,
  SETPASSWORDLINKCLICK: 730,
  CHANGEPASSWORDLINKCLICK: 731,
  DIALOGOKOPTIONCLICK: 732,
  SECURITYLINKCLICK: 733,
  TRYAGAINBUTTONCLICK: 734,
  SETORCHANGEPASSWORDRESULT: 735,
  APPLYNOWCLICKRESULT: 736,
  MESSAGENOTIFICATIONSETTINGRESULT: 737,
  NOTIFICATIONCLICK: 738,
  CHANGENOTIFICATIONTYPECLICK: 739,
  READALLBUTTONCLICK: 740,
  NOTIFICATIONLOADRESULT: 741,
  DIALOGCHANGEPASSWORDOPTIONCLICK: 742,
  CHANGEPASSWORDDIALOGSHOW: 743,
  LOADUSERSTATUSRESULT: 744,
  GETMOREREWARDSBUTTONCLICK: 745,
  MYLOANSBUTTONCLICK: 746,
  MYVOUCHERSBUTTONCLICK: 747,
  NOTIFICATIONSBUTTONCLICK: 748,
  HOMELINKCLICK: 749,
  PINTARSCORELINKCLICK: 750,
  PINTARSHOPLINKCLICK: 751,
  PRODUCTLINKCLICK: 752,
  FAQLINKCLICK: 753,
  ABOUTUSLINKCLICK: 754,
  CAREERLINKCLICK: 755,
  EDUCATIONLINKCLICK: 756,
  HEADERMENUBUTTONCLICK: 757,
  APPLYNOWBUTTONCLICK: 758,
  LEARNMOREBUTTONCLICK: 759,
  DOWNLOADBUTTONCLICK: 760,
  GETITONGOOGLEPLAYBUTTONCLICK: 761,
  GETITONAPPGALLERYBUTTONCLICK: 762,
  CHECKMYPINTARSCOREBADGECLICK: 763,
  PINTARSHOPBADGECLICK: 764,
  SITEMAPLINKCLICK: 765,
  FOLLOWUSBUTTONCLICK: 766,
  TANDCLINKCLICK: 767,
  PRIVACYPOLICYLINKCLICK: 768,
  ATTENTIONLINKCLICK: 769,
  DISCLAIMERLINKCLICK: 770,
  QUESTIONDETAILLINKCLICK: 771,
  CONTACTUSCLICK: 772,
  POSTSDETAILLINKCLICK: 773,
  KNOWMORELINKCLICK: 774,
  JOINUSNOWBUTTONCLICK: 775,
  READMORELINKCLICK: 776,
  CATEGORYLINKCLICK: 777,
  SEARCHBUTTONCLICK: 778,
  HOTSEARCHWORDCLICK: 779,
  HEADERNAVIGATIONAREALINKCLICK: 780,
  HOMECONTENTLOADRESULT: 781,
  CHANGEABLEBUTTONCLICK: 782,
  CLAIMBUTTONCLICK: 783,
  GETMOREREWARDSLINKCLICK: 784,
  CONGRATULATIONSDIALOGSHOW: 785,
  DIALOGCLOSEOPTIONCLICK: 786,
  DIALOGCONFIRMOPTIONCLICK: 787,
  CLAIMSUCCESSFULLYDIALOGSHOW: 788,
  DIALOGGOTOVIEWOPTIONCLICK: 789,
  OOPSDIALOGSHOW: 790,
  HOMEPOPUPSHOW: 791,
  HOMEPOPUPCLICK: 792,
  HOMEPOPUPCLOSE: 793,
  HOMEPOPUPCANCEL: 794,
  LOGINNOWBUTTONCLICK: 795,
  USEANOTHERACCOUNTBUTTONCLICK: 796,
  MESSAGERECEIVED: 797,
  PUSHSHOW: 798,
  SUBMITNOWBUTTONCLICK: 799,
  TANDCSAREACLICK: 800,
  GETMOREPOINTSBUTTONCLICK: 801,
  SELECTCATEGORYAREACLICK: 802,
  RECORDSCLICK: 803,
  COPYBUTTONCLICK: 804,
  SELECTPRODUCTOPTIONCLICK: 805,
  PLACEORDERBUTTONCLICK: 806,
  ORDERRESULTPOPUPSHOW: 807,
  CHECKMYORDERBUTTONCLICK: 808,
  COMPLETEDLINKCLICK: 809,
  SELECTBRANDAREACLICK: 810,
  SEARCHRESULT: 811,
  RECORDSTYPECLICK: 812,
  PROJECTPACKAGEPOPUPSHOW: 813,
  PROJECTPACKAGEPOPUPCLOSE: 814,
  PROJECTPACKAGEOPTIONCLICK: 815,
  INSURANCETANDCLINKCLICK: 816,
  CHECKOUTBUTTONCLICK: 817,
  APPLICATIONPREVIEWPOPUPSHOW: 818,
  APPLICATIONPREVIEWPOPUPCLOSE: 819,
  MESSAGEPOPUPCANCEL: 820,
  MESSAGEPOPUPCLICK: 821,
  MESSAGEPOPUPSHOW: 822,
  CONTENTLOADRESULT: 823,
  ADDBUTTONCLICK: 824,
  REDEEMVOUCHERRESULT: 825,
  BANKACCOUNTCHECKRESULT: 826,
  BANKACCOUNTVERIFICATIONDIALOGSHOW: 827,
  TRANSACTIONINPROGRESSLINKCLICK: 828,
  CONTENTLOADADAPTER: 829,
  CONFIRMBUTTONCLICK: 830,
  APPLYNOWPOPUPSHOW: 831,
  DIALOGAPPLYNOWOPTIONCLICK: 832,
  COUPONEXCHANGERESULT: 833,
  DIALOGTRYLATEROPTIONCLICK: 834,
  CASHBACKLINKCLICK: 835,
  REPAYMENTVOUCHERCLICK: 836,
  VOUCHERSAREACLICK: 837,
  USEBUTTONCLICK: 838,
  VOUCHERFAILEDDIALOGSHOW: 839,
  DIALOGRESUBMITOPTIONCLICK: 840,
  SLIDEGUESTRUECAPTURE: 841,
  CLICKABLEHOTAREACLICK: 842,
  FAQBUTTONCLICK: 843,
  COINSBUTTONCLICK: 844,
  ADLOADRESULT: 845,
  SKUAREACLICK: 846,
  VIEWALLLINKCLICK: 847,
  PLACEORDERRESULT: 848,
  COINSNOTENOUGTHPOPUPSHOW: 849,
  POPUPEARNCOINSOPTIONCLICK: 850,
  MYCOINSAREACLICK: 851,
  EXCHANGERECORDAREACLICK: 852,
  PLAYVIDEOAREACLICK: 853,
  WATCHMOREPOPUPSHOW: 854,
  POPUPWATCHNOWOPTIONCLICK: 855,
  MYSAVINGACCOUNTLINKCLICK: 856,
  AGREEANDOPENREPORTBUTTONCLICK: 857,
  POPUPCLOSEOPTIONCLICK: 858,
  POPUPCANCELOPTIONCLICK: 859,
  PINTARREPORTAREACLICK: 860,
  KTPCHECKRESULT: 861,
  KTPAREACLICK: 862,
  CREDITSCOREUSEDFORLINKCLICK: 863,
  ACCOUNTAREACLICK: 864,
  CONTINUEBUTTONCLICK: 865,
  CHECKACCOUNTNUMBERLINKCLICK: 866,
  SENDVOICECODELINKCLICK: 867,
  OTPCHECKRESULT: 868,
  QUESTIONLINKCLICK: 869,
  DIRECTDEBITTABCLICK: 870,
  LINKORCREATEACCOUNTBUTTONCLICK: 871,
  PAYNOWBUTTONCLICK: 872,
  TRANSACTIONAMOUNTFIELDCHANGE: 873,
  PAYNOWCONFIRMBUTTONCLICK: 874,
  REPAYMENTRESULT: 875,
  HOWTOPAYBUTTONCLICK: 876,
  IALREADYPAIDBUTTONCLICK: 877,
  CREATENEWVIRTUALACCOUNTBUTTONCLICK: 878,
  GETPAYMENTCODEBUTTONCLICK: 879,
  OCRCHECKRESULT: 880,
  INPUTFIELDCHANGE: 881,
  PROCEEDBUTTONCLICK: 882,
  SENDBUTTONCLICK: 883,
  LINKSCLICK: 884,
  TAKEPHOTORESULT: 885,
  SELECTORFIELDFOCUSED: 886,
  RETAKEBUTTONCLICK: 887,
  KTPSAVECHECKRESULT: 888,
  TAKEPHOTOBUTTONCLICK: 889,
  FACENOTMATCHDIALOGSHOW: 890,
  FACEVERIFICATIONCHECKRESULT: 891,
  DOWNLOADAPPANDGETCASHBUTTONCLICK: 892,
  CREDITAPPLICATIONRESULT: 893,
  DOWNLOADAPPBUTTONCLICK: 894,
  GETCASHBUTTONCLICK: 895,
  REPAYBUTTONCLICK: 896,
  HOMEPAGEBUTTONCLICK: 897,
  LOANAPPLICATIONRESULT: 898,
  REFRESHBUTTONCLICK: 899,
  LOANAGREEMENTLINKCLICK: 900,
  LOCATIONSTATUSADAPTOR: 901,
  USERSTATUSCHECKRESULT: 902,
  SHARENOWBUTTONCLICK: 903,
  SHARETARGETBUTTONCLICK: 904,
  TOTALREWARDSLINKCLICK: 905,
  POINTSCENTERLINKCLICK: 906,
  TASKSBUTTONCLICK: 907,
  GOOGLEPLAYRATEREQUESTRESULT: 908,
  REQUESTBIOMETRICINFORESULT: 909,
  BAGESAREACLICK: 910,
  REDEEMORTOUSEBUTTONCLICK: 911,
  DIALOGSHOW: 912,
  DIALOGCLICK: 913,
  WEBVIEWLOADRESULT: 914,
  REDEEMABLETOKENSLINKCLICK: 915,
  TOTALTOKENSLINKCLICK: 916,
  GUIDEHANDAREACLICK: 917,
  VIEWDETAILEDREDEEMRATIOLINKCLICK: 918,
  SENDCODEBUTTONCLICK: 919,
  EMAILOTPCHECKRESULT: 920,
  FLOATINGBUTTONCLICK: 921,
  DIALOGOPTIONCLICK: 922,
  ADDBANKCARDBUTTONCLICK: 923,
  CASHBACKCOUPONCLAIMRESULT: 924,
  GETFORFREEBUTTONCLICK: 925,
  GOBUTTONCLICK: 926,
  GOTOUSEBUTTONCLICK: 927,
  RATEPOPUPSHOW: 928,
  RATEPOPUPOPTIONCLICK: 929,
  AGREERADIOCLICK: 930,
  MUSTAGREEDIALOGSHOW: 931,
  DIALOGAGREEANDCONTINUEOPTIONCLICK: 932,
  SELECTALLRATIOCLICK: 933,
  LOANPURPOSECLICK: 934,
  NAVIGATIONLINKCLICK: 935,
  LOANPRODUCTCLICK: 936,
  APPLYLOANPREBORROWPAGEVIEW: 937,
  AMBILGRATISBUTTONCLICK: 938,
  FRIENDSLINKCLICK: 939,
  TOPUPLINKCLICK: 940,
  TERMSANDCONDITIONSPOPSHOW: 941,
  CONFIRMMOBILENOBUTTONCLICK: 942,
  DIALOGDETENTIONCLOSEOPTIONCLICK: 943,
  DIALOGDETENTIONOKOPTIONCLICK: 944,
  DIALOGREWARDCLOSEOPTIONCLICK: 945,
  DIALOGREWARDOKOPTIONCLICK: 946,
  REMINDFRIENDBUTTONCLICK: 947,
  TERMSPOPUPSHOW: 948,
  AGREEANDCONTINUEBUTTONCLICK: 949,
  TERMSSWITCH: 950,
  TERMSUPDATEDIALOGSHOW: 951,
  DIALOGNOOPTIONCLICK: 952,
  DIALOGACCEPTOPTIONCLICK: 953,
  DIALOGTERMSOFSERVICEOPTIONCLICK: 954,
  DIALOGPRIVACYPOLICYOPTIONCLICK: 955,
  LIVENESSRESULT: 956,
  PAGERENDERRESULT: 957,
  SCROLLTOBOTTOMBUTTONCLICK: 958,
  SLIDEGESTURECAPTURE: 959,
  DOCUSDKLOADRESULT: 960,
  AGREEBUTTONACTIVATED: 961,
  CLICK: 962,
  DIALOGDISMISS: 963,
  POPUPDISMISS: 964,
  INPUTFIELDBLUR: 965,
  DIALOGDISPLAY: 966,
  DIALOGCONFIRM: 967,
  DIALOGCANCEL: 968,
  BACKCLICK: 969,
  LIVENESSKEYREQUESTRESULT: 970,
  HOMEPOPUPBUTTONCLICK: 971,
  PHONENOREQUESTRESULT: 972,
  JAGOUSERTYPEREQUESTRESULT: 973,
  TERMSRADIOBUTTONCLICK: 974,
  JAGOACCOUNTREGISTERREQUESTRESULT: 975,
  JAGOACCOUNTINFOREQUESTRESULT: 976,
  PINTAR_APP_DEBUG: 977,
  INPUTDELETE: 978,
  SELECTORCLICK: 979,
  SELECTORCHANGE: 980,
  JOINNOWBUTTONCLICK: 981,
  PHONENUMBERCONFIRMCLICK: 982,
  TERMSANDCONDITIONSCLICK: 983,
  REWARDSFRIENDSCLICK: 984,
  REWARDSTOPUPCLICK: 985,
  REMINDFRIENDCLICK: 986,
  WAVERIFYRESULT: 987,
  LOGINWITHWACLICK: 988,
  KEEPCLICK: 989,
  VERIFICATIONCODECLICK: 990,
  SMSOTPVERIFYCLICK: 991,
  JAGOJUMPRESULT: 992,
  CAPTCHASWITCHREQUESTRESULT: 993,
  CAPTCHACHECKINGFAILURE: 994,
  LOGINMETHODREQUESTRESULT: 995,
  JUMPOUTCLICK: 996,
  SECURITYCHECKLINKCLICK: 997,
  ACCOUNTSECURITYCHECKRESULT: 998,
  BROWSERLOCATIONACCESS: 999,
  LOCATIONACCESSAUDITRESULT: 1000,
  BILLINSTALLMENTAPPLICATIONREQUESTRESULT: 1001,
  INSTALLMENTAPPLICATIONOPERATIONCLICK: 1002,
  APPLYBILLINSTALLMENTCLICK: 1003,
  INSTALLMENTAPPLICATIONREQUESTRESULT: 1004,
  MANAGEACCOUNTCLICK: 1005,
  DELETEACCOUNTCLICK: 1006,
  DELETEACCOUNTRESULT: 1007,
  DECLARECLICK: 1008,
  VALIDATERESULT: 1009,
  DBRRESTRICTIONRESULT: 1010,
  UPDATEINFOCLICK: 1011,
  LOANPRODUCTSHOW: 1012,
  FLEXIBLEPRODUCTAPPLYCLICK: 1013,
  PAYADVANCEAMOUNTCLICK: 1014,
  TENORCLICK: 1015,
  CHANGEAMOUNTSLIDE: 1016,
  MOREFLEXIBILITYCLICK: 1017,
  INSTALLMENTREMINDERCHECKCLICK: 1018,
  SCHEDULEDREMINDERCLICK: 1019,
  ONGOINGREMINDERCLICK: 1020,
  ADDREMINDERCLICK: 1021,
  SUBMITREMINDERCLICK: 1022,
  ENABLEBIOMETRIC: 1023,
  DISABLEBIOMETRIC: 1024,
  ENABLEBIOMETRICRESULTCHECK: 1026,
  BIOMETRICLOGIN: 1025,
  CONFIRMREDEEM: 1027,
  ADDBANKCARD: 1028,
  EMAILLINKSHOW: 1029,
  CHANGEEMAILVERIFICATIONTYPE: 1030,
  SWITCHBUTTONSHOW: 1031,
  TESTACTION: 1032,
  SWITCHBUTTONCLICK: 1033,
}

goog.object.extend(exports, proto.advai_event.pintar_id)
